import React from "react";

const VerticalRule = (props) => (
	<div
		{...props}
		style={{
			...{
				height: '100%', width: '1px', backgroundColor: 'black', display: 'inline-block'
			},
			...props.style
		}}
	/>
);

export default VerticalRule;
